/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Modal } from 'react-bootstrap';
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import "../../styles/admin_user_nav.css"
import { addUser, getSupervisorByDeptAndRoleId } from "../actions/userAction";
// import { getDepartment } from "../../login/actions/loginAction";
import userLabels from '../labels/users_en.json';
import _ from "lodash/fp";
import { emailRegex } from "../../../common/constants/regex";
import { toastr } from 'react-redux-toastr';

import docLabels from '../../documentsverification/labels/documentlabel.json'

const EditActiveUser = (props) => {

    const { register, handleSubmit, errors, watch } = useForm({
        mode: "onChange"
    });

    const { allDepartments } = useSelector((state) => state.common,
        shallowEqual
    );
    const { roleByDept, supervisorByRole } = useSelector((state) => state.userManagementReducer,
        shallowEqual
    );
    let userData;
    if (props.userData) {
        userData = props.userData;
    }
    useEffect(() => {
        // dispatch(getDepartment());
        // eslint-disable-next-line
    }, [])

    const [departmentList, setDeparmentList] = useState("")
    const [roleList, setRoleList] = useState("")
    const [supervisorList, setSupervisorList] = useState("")
    let [showDeleteModal, setShowDeleteModal] = useState(false)
    const [editSaveFlag, seteditSaveFlag] = useState(false)
    const [assignAnotherFlag, setassignAnotherFlag] = useState(false)
    const [newAssignedRoleDept, setnewAssignedRoleDept] = useState([])

    function setNewDept(allDepartments, departmentList) {
        return allDepartments && allDepartments.find(ele => {
            return ele.id == departmentList
        })
    }

    function setNewRole(roleByDept, roleList) {
        return roleByDept && roleByDept.find(ele => {
            return ele.id == roleList
        })
    }

    function setNewsupervisor(supervisorByRole, supervisorList) {
        return supervisorByRole && supervisorByRole.find(ele => {
            return ele.id == supervisorList
        })
    }

    const handleChangeDepartment = (e) => {

        setDeparmentList(e.target.value)
        if (e.target.value) {

            getSupervisor()
        }
    }
    const handleChangeRole = (e) => {
        setRoleList(e.target.value)
        getSupervisor()
    }
    const handleChangeSupervisor = (e) => {
        setSupervisorList(e.target.value)
    }

    const getSupervisor = () => {
        let deptId = watch("departmentList");
        dispatch(getSupervisorByDeptAndRoleId(deptId))
    }
    const [assignAnother, setAssignAnother] = useState(
        userData && userData.userOasDeptRoleList
    );


    useEffect(() => {
        setAssignAnother(userData && userData.userOasDeptRoleList)
        seteditSaveFlag(false)
        // eslint-disable-next-line
    }, [userData && userData.userOasDeptRoleList])

    const cancelModal = () => {
        props.setShowModal(false)
        seteditSaveFlag(false);
        setassignAnotherFlag(false)
        setDeparmentList("")
        setRoleList("")
        setSupervisorList("")
        setAssignAnother(userData && userData.userOasDeptRoleList)
    }
    const handleDeleteActiveUser = (ele) => {
        setShowDeleteModal(true)
    }
    const comfirmDeleteUserModal = (ele) => {
        let requestBody = {};
        requestBody.userOasApproval = {
            "approvalType": "Delete User",
            "email": userData.userOas.email,
            "mobile": userData.userOas.mobile,
            "isSuperAdmin": userData.userOas.isSuperAdmin,
            "isActive": true,
            "firstName": userData.userOas.firstName,
            "lastName": userData.userOas.lastName,
            "createdAt": userData.userOas.createdAt,
            "userOasId": userData.userOas.id

        }
        requestBody.userOasApprovalDeptRoleDto = []
        dispatch(addUser(requestBody))
        setShowDeleteModal(false)
        props.setShowModal(false)
    }

    const checkDefaultDeptRole = (deptId, roleId, supervisorId) => {
        const array = []

        userData && assignAnother && assignAnother.map((ele, index) => {
            if (deptId == ele.department.id && roleId == ele.role.id) {
                array.push(true)
            } else {
                array.push(false)
            }
        })

        return array && array.every(a => a == false)
    }

    const onSubmit = (data) => {

        let userOasDeptRoleListId;
        let newDeptRoleVerify = true;
        if (editSaveFlag) {
            userOasDeptRoleListId = userData && userData.userOasDeptRoleList[0].id
        }
        let requestBody = {};
        requestBody.userOasApproval = {
            "approvalType": "Edit User",
            "email": data.email,
            "mobile": data.mobile,
            "password": "Vast@123",
            "isSuperAdmin": userData.userOas.isSuperAdmin,
            "isActive": userData.userOas.isActive,
            "firstName": data.firstName,
            "lastName": data.lastName,
            "createdAt": userData.userOas.createdAt,
            "userOasId": userData.userOas.id,
        }
        requestBody.userOasApprovalAction = {
            "action": "Edit user",
            "comments": data.comment.trim(),
            "userOasId": userData.userOas.id
        }
        if (data.departmentList && editSaveFlag) {
            requestBody.userOasApprovalDeptRoleDto = [
                {
                    "isActive": true,
                    "userOasDeptRoleId": userOasDeptRoleListId,
                    "supervisor": {
                        "id": data.supervisorList
                    },
                    "role": {
                        "id": data.roleList
                    },
                    "department": {
                        "id": data.departmentList
                    }
                }
            ]
            newDeptRoleVerify = checkDefaultDeptRole(data.departmentList, data.roleList, data.supervisorList)
        } else if (assignAnotherFlag) {
            requestBody.userOasApprovalDeptRoleDto = newAssignedRoleDept
        }
        else {
            requestBody.userOasApprovalDeptRoleDto = [];
        }

        if (newDeptRoleVerify == true) {
            dispatch(addUser(requestBody))
        } else {
            toastr.error("Department and Role already exists.")
        }

        props.setShowModal(false)
        setDeparmentList("")
        setRoleList("")
        setSupervisorList("")
        setassignAnotherFlag(false)
    }

    const handleAssignAnother = () => {
        if (departmentList && roleList && supervisorList) {
            let list = [...assignAnother]
            list.push(
                {
                    id: assignAnother.length + 1,
                    userOasId: assignAnother[0].userOasId,
                    department: setNewDept(allDepartments, departmentList),
                    role: setNewRole(roleByDept, roleList),
                    supervisor: setNewsupervisor(supervisorByRole, supervisorList)

                }
            )

            setDeparmentList("")
            setRoleList("")
            setSupervisorList("")
            if (checkDefaultDeptRole(departmentList, roleList, supervisorList)) {
                setassignAnotherFlag(true)
                setAssignAnother(list)
                setnewAssignedRoleDept([{
                    "isActive": true,

                    "supervisor": {
                        "id": supervisorList
                    },
                    "role": {
                        "id": roleList
                    },
                    "department": {
                        "id": departmentList
                    }
                }])
            } else {
                toastr.error("Department and Role already exists.")
            }
        }

    }
    const editItem = (ele) => {
        let deptId = ele.department.id
        let roleId = ele.role.id
        let supervisorId = ele && ele.supervisor && ele.supervisor.id
        dispatch(getSupervisorByDeptAndRoleId(deptId))
        setDeparmentList(deptId)
        setRoleList(roleId)
        setSupervisorList(supervisorId)

        seteditSaveFlag(true)
    }

    const deleteRowItem = (ele) => {
        let requestBody = {}
        requestBody.userOasApproval = {
            "approvalType": "Edit User",
            "email": watch("email"),
            "mobile": watch("mobile"),
            "password": "Vast@123",
            "isSuperAdmin": userData.userOas.isSuperAdmin,
            "isActive": userData.userOas.isActive,
            "firstName": watch("firstName"),
            "lastName": watch("lastName"),
            "createdAt": userData.userOas.createdAt
        }
        requestBody.userOasApprovalDeptRoleDto = [
            {
                "userOasDeptRoleId": ele.id,
                "isActive": false,
                "supervisor": {
                    "id": ele.supervisor.id
                },
                "role": {
                    "id": ele.role.id
                },
                "department": {
                    "id": ele.department.id
                }
            }
        ]
        dispatch(addUser(requestBody))
    }
    return (
        <div>
            <form>
                <Modal size="lg" show={props.showModal} onHide={cancelModal} aria-labelledby="example-modal-sizes-title-lg" backdrop='static'>
                    <Modal.Header className="logout_heading">
                        <Modal.Title className="logout_title">
                            {props.header}
                        </Modal.Title>
                         <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={cancelModal}
                    >X</button>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="Note-color">Note:Edit either of the below fields at a time- First Name/Last Name/Email-Id/Mobile no. or Department/Role/Supervisor</p>
                        <div className="row" >
                            <div className="form-group col-md-6 mb-0">
                                <label className="LeftText">{userLabels.FIRST_NAME} <span className="redColor">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="firstName"
                                    defaultValue={userData && userData.userOas && userData.userOas.firstName}
                                    ref={register({
                                        required: true, pattern: {
                                            value: /^[A-Za-z_.]+$/i
                                        }, maxLength: 30
                                    })}
                                />
                                {_.get("firstName.type", errors) === "required" && (
                                    <p className="errorText">{userLabels.MANDATORY_FIELD_MESSAGE}</p>
                                )}
                                {_.get("firstName.type", errors) === "pattern" && (
                                    <p className="errorText">{userLabels.ENTER_VALID_FIRSTNAME}</p>
                                )}
                                {_.get("firstName.type", errors) === "maxLength" && (
                                    <p className="errorText">{userLabels.MAX_VALUE_FOR_30_CHAR}</p>
                                )}

                            </div>
                            <div className="form-group col-md-6 mb-0">
                                <label className="LeftText">{userLabels.LAST_NAME}<span className="redColor">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="lastName"
                                    defaultValue={userData && userData.userOas && userData.userOas.lastName}
                                    ref={register({
                                        required: true, pattern: {
                                            value: /^[A-Za-z_.]+$/i
                                        }, maxLength: 30
                                    })}
                                />
                                {_.get("lastName.type", errors) === "required" && (
                                    <p className="errorText">{userLabels.MANDATORY_FIELD_MESSAGE}</p>
                                )}
                                {_.get("lastName.type", errors) === "pattern" && (
                                    <p className="errorText">{userLabels.ENTER_VALID_LASTNAME}</p>
                                )}
                                {_.get("lastName.type", errors) === "maxLength" && (
                                    <p className="errorText">{userLabels.MAX_VALUE_FOR_30_CHAR}</p>
                                )}
                            </div>
                            <div className="form-group col-md-6 mb-0">
                                <label className="LeftText">{userLabels.EMAIL_ID}<span className="redColor">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="email"
                                    defaultValue={userData && userData.userOas && userData.userOas.email}
                                    ref={register({ required: true, pattern: emailRegex })}
                                />
                                {_.get("email.type", errors) === "required" && (
                                    <p className="errorText">{userLabels.MANDATORY_FIELD_MESSAGE}</p>
                                )}
                                {_.get("email.type", errors) === "pattern" && (
                                    <p className="errorText">{userLabels.ENTER_VALID_EMAIL}</p>
                                )}
                            </div>
                            <div className="form-group col-md-6 mb-0">
                                <label className="LeftText">{userLabels.MOBILE_NUMBER}<span className="redColor">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="mobile"
                                    defaultValue={userData && userData.userOas && userData.userOas.mobile}
                                    maxLength={10}
                                    ref={register({
                                        required: true,
                                        pattern: {
                                            value: /^\s*([1-9]{1}[0-9]{9})\s*$/
                                        }
                                    })}
                                />
                                {_.get("mobile.type", errors) === "required" && (
                                    <p className="errorText">{userLabels.MOBILE_REQ}</p>
                                )}
                                {_.get("mobile.type", errors) === "pattern" && (
                                    <p className="errorText">{userLabels.MOBILE_PATTERN}</p>
                                )}
                            </div>


                        </div>
                        <br />
                        <div style={{ height: "150px", overflowY: "auto", overflowX: "hidden" }}>

                            <table className="table table-bordered table-sm" >
                                <thead>
                                    <tr>
                                        <th scope="col">Sr No</th>
                                        <th scope="col">Department</th>
                                        <th scope="col">Role</th>
                                        <th scope="col">Supervisor</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: "12px" }}>
                                    {userData && assignAnother && assignAnother.map((ele, index) => {
                                        if (ele) {
                                            return (
                                                // <tr key={index}>
                                                //     <td>{index+1}</td>
                                                //     <td>{ele.department.name}</td>
                                                //     <td>{ele.role.name}</td>
                                                //     <td>{ele.supervisor.firstName} {ele.supervisor.lastName}</td>
                                                //     <td>
                                                //     <i className='fa fa-edit' onClick={()=> {editItem(ele)}}></i>&nbsp;
                                                //     <i style={{color:"red"}} className='fa fa-trash' aria-hidden="true" onClick={()=> {deleteItem(index)}}></i>
                                                //     </td>

                                                // </tr>
                                                <tr key={index}>
                                                    <td className="w-10 word-break text-center">{index + 1}</td>
                                                    <td className="word-break">{ele.department && ele.department.name}</td>
                                                    <td className="word-break">{ele.role && ele.role.name}</td>
                                                    <td className="word-break">{ele.supervisor && ele.supervisor.firstName} {ele.supervisor && ele.supervisor.lastName}</td>
                                                    <td className="w-10 word-break text-center">
                                                        <i style={{ color: "#007bff", cursor: 'pointer' }} data-toggle="tooltip" title="Edit" className='fa fa-edit' onClick={() => { editItem(ele) }}></i>&nbsp;&nbsp;
                                                        {
                                                            userData && userData.userOasDeptRoleList.length === 1 ? "" : <i style={{ color: "red", cursor: 'pointer' }} data-toggle="tooltip" title="Delete" className='fa fa-trash' onClick={() => { deleteRowItem(ele) }}></i>
                                                        }

                                                        {/* <i style={{color:"red", cursor: 'pointer'}}  data-toggle="tooltip" title="Delete" className={`fa fa-trash ${userData && userData.userOasDeptRoleList.length === 1?"disabled-link" : ""} `} disabled={userData && userData.userOasDeptRoleList.length === 1} onClick={()=> {deleteRowItem(ele)}}></i> */}
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    })
                                    }
                                </tbody>
                            </table>


                            <div className="row" >
                                <div className="form-group col-md-4 mb-0">
                                    <label className="LeftText">Department
                                    </label>
                                    <select className="form-control" name="departmentList" value={departmentList} onInput={handleChangeDepartment} ref={register({ required: false })}>
                                        <option key="" value="">Select</option>
                                        {allDepartments && allDepartments.map((ele, i) => {
                                            return <option key={i} value={ele.id}>{ele.name}</option>
                                        })}
                                    </select>
                                </div>
                                <div className="form-group col-md-4 mb-0">
                                    <label className="LeftText">Role
                                    </label>
                                    <select className="form-control" name="roleList" value={roleList} disabled={!departmentList} onInput={handleChangeRole} ref={register({ required: false })}>
                                        <option key="" value="">Select</option>
                                        {roleByDept && roleByDept.map((ele, index) =>
                                            <option key={index} value={ele.id}>{ele.name}</option>
                                        )}
                                    </select>
                                </div>
                                <div className="form-group col-md-3 mb-0">
                                    <label className="LeftText">Supervisor
                                    </label>
                                    <select className="form-control" name="supervisorList" value={supervisorList} disabled={!departmentList && !roleList} onInput={handleChangeSupervisor} ref={register({ required: false })}>
                                        <option key="" value="">Select</option>
                                        {supervisorByRole && supervisorByRole.map((ele, index) => {
                                            return <option key={index} value={ele.id}>{ele.firstName}</option>
                                        })}
                                    </select>
                                </div>
                                <div className="form-group col-md-1 mb-0">
                                </div>
                            </div>

                        </div>

                        {editSaveFlag === false ?
                            <button type="button" className=" btn btn-primary custom_button  btn-sm pull-right"  onClick={handleAssignAnother} disabled={assignAnotherFlag}>Assign Another</button> : ""}
                        <div className="form-group mt-4">
                            <h6 style={{ fontWeight: 'bold' }}>Comments<span className="redColor">*</span></h6>
                            <h6 >
                                <input
                                    type="text"
                                    className="form-control"
                                    name="comment"
                                    maxLength={255}
                                    placeholder={docLabels.ENTER_TEXT_UPTO_255_CHARACTERS}
                                    ref={register({ required: true })}
                                /></h6>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-danger" onClick={() => { handleDeleteActiveUser() }}>Delete User</button>
                        <button className="btn btn-secondary" onClick={cancelModal}>{userLabels.CANCEL}</button>
                        {departmentList && (editSaveFlag === false) ?
                            <button className=" btn btn-primary custom_button user_management_button" type="submit" onClick={handleSubmit((e) => { onSubmit(e) })} disabled={!assignAnotherFlag}>{userLabels.SAVE}</button> :
                            <button className=" btn btn-primary custom_button user_management_button" type="submit" onClick={handleSubmit((e) => { onSubmit(e) })}>{userLabels.SAVE}</button>}
                        {/* <button className=" btn btn-primary custom_button "  type="submit" onClick={handleSubmit((e) => { onSubmit(e) })}>{userLabels.SAVE}</button> */}
                    </Modal.Footer>
                </Modal>
            </form>
            <Modal show={showDeleteModal} onHide={() => { setShowDeleteModal(false) }} backdrop='static'>
                <Modal.Header className="logout_heading">
                    <Modal.Title className="logout_title">Delete Active User</Modal.Title>
                        <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={() => { setShowDeleteModal(false); seteditSaveFlag(false); }}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                    <label>Are you sure you want to delete this User?</label>

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => { setShowDeleteModal(false); seteditSaveFlag(false); }}>Cancel</button>
                    <button className=" btn btn-primary custom_button   " onClick={() => { comfirmDeleteUserModal() }} >Confirm</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}



export default EditActiveUser